import React from "react";
import "./SectionHeadingStyle.scss";

function SectionHeading({ className, headingTextClass, headingImgClass, children }) {
  return (
    <div className={`heading-text-box ${className}`}>
      <img src="/assets/svg-img/triangle-shape.svg" className={`heading-img ${headingImgClass}`} alt="Image" />
      <h1 className={`heading-text ${headingTextClass}`}>{children}</h1>
    </div>
  );
}

export default SectionHeading;
